export default __webpack_public_path__ + "static/media/cat2-1-3.2b43fc29.jpg";